<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="width: 70px;">订单号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderNo" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="width: 70px;">用户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width: 80px;">订单状态:</div>
            <div class="flex1">
              <el-select
                  v-model="queryInfo.status"
                  multiple
                  size="small"
                  collapse-tags
                  placeholder="请选择"
                  @change="handleStatusChange">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="24" class="display-row" style="margin-top: 10px;">
            <div style="text-align:right;width:100%;float:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button style="margin-right: 0!important;" class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item"> 订单收入总额：{{addThousandSeparator(form.totalIncomeFee)}}元
            <el-tooltip effect="light" content="中国运费和检品费是订单购买完时的金额" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <span class="tip-item">采购成本总额（商品费+中国运费）{{addThousandSeparator(form.totalPurchaseCost)}}元</span>
          <span class="tip-item">订单毛利总额 （收入-采购成本）{{addThousandSeparator(form.totalNetFee)}}元</span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="userName" align="center" label="用户ID">
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="下单日期">
            <template v-slot="scope">
              <div style="white-space: pre-wrap;"> {{ scope.row.createTime | dateFormatToSecond2 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单号">
          </el-table-column>
<!--          <el-table-column prop="goodsNameCus" align="center" label="品名">-->
<!--          </el-table-column>-->
          <el-table-column prop="goodsNameCus" align="center" label="订单状态">
            <template v-slot="{row}">
              <div style="white-space: pre-wrap;">{{getStatus(row.status)}}</div>
            </template>

          </el-table-column>
          <el-table-column prop="price" align="center" label="单价">
          </el-table-column>
          <el-table-column prop="goodsCount" align="center" label="数量">
          </el-table-column>
          <el-table-column prop="goodsFee" align="center" label="商品费">
          </el-table-column>
          <el-table-column prop="agentServiceFee" align="center" label="代购手续费((商品费+中国运费)*6%)"></el-table-column>
          <!-- <el-table-column prop="commission" align="center" label="手续费:(单价*数量)*5%">
            <template v-slot="scope">
              {{ ((scope.row.price*scope.row.goodsCount) * 0.05).toFixed(2) }}
            </template>
          </el-table-column> -->
          <el-table-column prop="inlandFreight" align="center" label="中国运费">
          </el-table-column>
          <el-table-column prop="inspectionFee" align="center" label="检品费">
          </el-table-column>
<!--          <el-table-column prop="labelFee" align="center" label="标签费">-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="categoryPrice" align="center" label="仓库保管费">-->
<!--          </el-table-column>-->
          <el-table-column prop="incomeFee" align="center" label="订单合计">
          </el-table-column>
          <el-table-column prop="currencyAmount" align="center" label="订单合计 + 币种">
            <template v-slot="{row}">
              <div style="white-space: pre-wrap;color: #ffa621;">{{ formatSettlementAmount(row) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="purchaseCost" align="center" label="采购成本">
          </el-table-column>
          <el-table-column prop="total" align="center" label="毛利">
          </el-table-column>
          <el-table-column prop="currencyRate" align="center" label="汇率">
            <template v-slot="{row}">
              {{ formatSettlementRate(row) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'orderIncome',
  data () {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1,
        userName:"",
        orderNo:"",
        status: []
      },
      previousStatus: [],
      recordList: [],
      total: 0,
      form: {},
      options: [
      {
        value: '',
        label: '全部'
      },
          {
        value: '99',
        label: '待确认'
      }, {
        value: '1',
        label: '待购买'
      }, {
        value: '2',
        label: '购买完'
      }, {
        value: '0',
        label: '等待到库'
      }, {
          value: '4',
          label: '已到货'
        }
        , {
          value: '88',
          label: '检品完'
        }
        , {
          value: '5',
          label: '仓库保管中'
        }, {
          value: '8',
          label: '已完成'
        }, {
          value: '24',
          label: '不良待处理'
        }, {
          value: '16',
          label: '仓库保管中'
        }
        , {
          value: '26',
          label: '不良驳回'
        }
        , {
          value: '28',
          label: '换货待发回'
        }
        , {
          value: '32',
          label: '换货等待到货'
        }
        , {
          value: '36',
          label: '待部分退货'
        }
        , {
          value: '40',
          label: '补发等待到货'
        }

        , {
          value: '48',
          label: '待发送'
        }
        , {
          value: '52',
          label: '已发送'
        }
        , {
          value: '56',
          label: '已取消'
        }

        , {
          value: '68',
          label: '待退货'
        }
        , {
          value: '72',
          label: '已退货'
        }
        , {
          value: '76',
          label: '销毁申请中'
        }

        , {
          value: '82',
          label: '待部分销毁'
        }
        , {
          value: '83',
          label: '待销毁'
        }
        , {
          value: '84',
          label: '已销毁'
        }
        , {
          value: '89',
          label: '无法购买'
        }
      ],
    }
  },
  methods: {
    handleStatusChange(selectedValues) {
      const allValue = '';
      const statusValues = this.options
        .map(item => item.value)
        .filter(value => value !== allValue);
      const values = selectedValues || [];
      const currentHasAll = values.includes(allValue);
      const previousHasAll = this.previousStatus.includes(allValue);
      const hasEveryStatus = statusValues.every(value => values.includes(value));
      let nextStatus = values;

      if (currentHasAll && !previousHasAll) {
        nextStatus = [allValue, ...statusValues];
      } else if (!currentHasAll && previousHasAll && hasEveryStatus) {
        nextStatus = [];
      } else if (currentHasAll && !hasEveryStatus) {
        nextStatus = values.filter(value => value !== allValue);
      } else if (!currentHasAll && hasEveryStatus) {
        nextStatus = [allValue, ...statusValues];
      }

      this.queryInfo.status = nextStatus;
      this.previousStatus = [...nextStatus];
    },
    handleLegacyStatusChange(selectedValues) {
      this.$nextTick(() => {
        if (selectedValues.includes('') && selectedValues.length > 1) {
          // 判断是否选择"全部"
          const previousHasAll = this.queryInfo.status.at(-1) == '';
          if (!previousHasAll) {
            // 之前有"全部"，现在选择了其他选项，移除"全部"
            this.queryInfo.status = selectedValues.filter(value => value !== '');
          } else {
            // 选择"全部"
            this.queryInfo.status = [''];
          }
        } else {
          this.queryInfo.status = selectedValues;
        }
      });
    },
    getStatus(value){
      let str = ''
      for (let i = 0; i < this.options.length; i++) {
        if(this.options[i].value == value){
          str = this.options[i].label
        }
      }
      return str

    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction () {
      const params = {
        ...this.queryInfo,
        status: this.queryInfo.status.includes('') ? '' : this.queryInfo.status.join(','),
      }
      this.$http({
        url: '/financial/exportOrderIncome',
        method: 'get',
        params,
        // params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '订单收入统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList () {
      const params = {
        ...this.queryInfo,
        status: this.queryInfo.status.includes('') ? '' : this.queryInfo.status.join(','),
      }
      const { data: res } = await this.$http.get('/financial/queryOrderIncome', { params });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      this.queryInfo.orderNo = ''
      this.queryInfo.userName = ''
       this.queryInfo.endDate= ''
      this.queryInfo.startDate = ''
      this.queryInfo.status = []
      this.previousStatus = []
    },
    async getTool () {
      const params = {
        ...this.queryInfo,
        status: this.queryInfo.status.includes('') ? '' : this.queryInfo.status.join(','),
      }
      const { data: res } = await this.$http.get('/financial/queryOrderIncomeHeader', { params });
      this.form = res.data
    }
  },
    activated () {
    this.getrecordList();
  },
  created () {
    this.getrecordList();
    this.getTool();
  }
};
</script>

<style lang="less" scoped>
.query-title{
  width: 95px;
  padding-left: 0;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.tips {
  margin: 15px 0;
  text-align: right;
}
.tip-item{
  margin-left: 30px;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
